export default __webpack_public_path__ + "static/media/nov2023-4.fc1b1d42.jpg";